var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _path5, _rect, _rect2, _rect3, _rect4, _path6, _circle5, _circle6, _circle7, _path7, _ellipse, _circle8, _circle9, _path8, _path9, _path10, _path11, _path12, _ellipse2, _ellipse3, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path13, _path14, _path15, _ellipse4, _rect5, _rect6, _rect7, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIlError640Px = function SvgIlError640Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 381,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M571.452 350.553c-27.933 21.906-24.101-5.855-46.04-33.847-8.907-14.009-32.494-47.347-41.937-61.003-17.255-31.098-38.323-31.544-7.277-48.758 43.383-33.772 95.16-6.124 116.636 26.254 21.383 32.238 20.447 89.609-21.382 117.354Z",
    fill: "#51795C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.041 194.745a112.341 112.341 0 0 0-16.056 10.092 98.3 98.3 0 0 1 9.595 6.347c10.623 7.933 20.353 18.277 28.571 29.863 9.03-9.56 14.164-18.652 16.106-23.85a99.313 99.313 0 0 1 4.248 4.267c-2.743 6.147-8.29 15.1-17.153 24.275a158.409 158.409 0 0 1 6.262 10.392c8.872 16.091 14.855 33.592 16.463 50.002 9.111-8.992 14.759-17.847 17.52-23.764a93.68 93.68 0 0 1-.948 12.655c-3.897 5.689-9.225 12.083-16.149 18.355.154 9.091-1.172 17.785-4.3 25.549a76.72 76.72 0 0 1-13.748 11.625c-.425.333-.843.655-1.253.965 8.762-8.353 13.076-19.995 13.682-33.373-6.342 5.036-13.779 9.849-22.403 13.986l-2.404-5.01c9.863-4.731 18.073-10.376 24.787-16.173-.805-16.655-6.722-35.102-16.113-52.133a152.579 152.579 0 0 0-5.438-9.1c-7.643 7.143-17.334 14.194-29.314 19.941l-2.404-5.01c11.803-5.661 21.238-12.631 28.575-19.605-8.037-11.485-17.57-21.682-27.912-29.405-3.578-2.672-7.239-5.038-10.957-7.057-14.735 12.44-22.512 25.745-24.892 32.333l-5.226-1.889c2.598-7.192 10.387-20.495 24.709-33.117-9.512-4.231-19.306-6.124-28.959-5.014l-.049-.419a70.53 70.53 0 0 1 11.322-5.148c7.634.796 15.158 3.127 22.398 6.649a116.811 116.811 0 0 1 13.442-9.167c2.7.507 5.369 1.157 7.998 1.938Z",
    fill: "#8BBA98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.206 341.992c26.506 23.613 24.42-4.334 48.07-30.896 9.767-13.424 35.396-45.219 45.676-58.256 19.169-29.957 40.223-29.082 10.317-48.207-41.182-36.423-94.59-12.073-118.052 18.896-23.36 30.835-26.02 88.151 13.989 118.463Z",
    fill: "#51795C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.317 188.394a112.455 112.455 0 0 1 15.393 11.079 98.312 98.312 0 0 0-9.974 5.733c-11.099 7.252-21.457 16.967-30.385 28.015-8.414-10.107-12.968-19.504-14.58-24.813a98.977 98.977 0 0 0-4.508 3.993c2.353 6.307 7.328 15.59 15.599 25.303a158.163 158.163 0 0 0-6.9 9.979c-9.863 15.503-16.93 32.595-19.564 48.872-8.53-9.547-13.613-18.739-15.997-24.817a93.61 93.61 0 0 0 .153 12.69c3.532 5.922 8.45 12.638 14.969 19.332-.724 9.064.055 17.825 2.692 25.771a76.643 76.643 0 0 0 12.99 12.46c.406.361.804.71 1.196 1.047-8.225-8.886-11.802-20.777-11.569-34.169 6.014 5.423 13.135 10.693 21.483 15.362l2.712-4.85c-9.546-5.34-17.387-11.488-23.724-17.694 1.846-16.571 8.908-34.612 19.347-51.021a152.788 152.788 0 0 1 5.997-8.741c7.18 7.607 16.411 15.252 28.008 21.738l2.712-4.85c-11.424-6.389-20.404-13.936-27.29-21.356 8.74-10.959 18.894-20.539 29.699-27.599 3.738-2.442 7.54-4.575 11.378-6.357 13.926 13.339 20.855 27.105 22.817 33.829l5.334-1.558c-2.143-7.34-9.082-21.105-22.585-34.599 9.758-3.627 19.651-4.903 29.216-3.191l.074-.415a70.594 70.594 0 0 0-10.977-5.847c-7.669.316-15.324 2.172-22.77 5.232a116.873 116.873 0 0 0-12.841-9.99 79.8 79.8 0 0 0-8.105 1.432Z",
    fill: "#8BBA98"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.339,
    cy: 28.339,
    transform: "matrix(-1 0 0 1 272.27 185.843)",
    fill: "#513520",
    r: 28.339
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.339,
    cy: 28.339,
    transform: "matrix(-1 0 0 1 201.143 184.176)",
    fill: "#513520",
    r: 28.339
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.339,
    cy: 28.339,
    transform: "matrix(-1 0 0 1 201.143 184.176)",
    fill: "#000",
    fillOpacity: 0.4,
    r: 28.339
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.339,
    cy: 28.339,
    transform: "matrix(-1 0 0 1 313.945 202.513)",
    fill: "#513520",
    r: 28.339
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M573.722 316.426c3.382 42.504-27.256 52.534-69.841 55.909-19.936-.385-37.088-.172-57.026.214-42.585-3.376-83.503-13.619-80.121-56.123-5.001-65.847 60.769-103.911 107.436-103.911 46.467 0 99.552 43.62 99.552 103.911Zm-292.015 0c3.381 42.504-27.256 52.534-69.841 55.91-19.937-.386-37.089-.173-57.027.213-42.584-3.376-83.503-13.619-80.12-56.123-5.002-65.847 60.769-103.911 107.436-103.911 46.466 0 99.552 43.62 99.552 103.911Z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 432.859,
    y: 183.269,
    width: 44.453,
    height: 65.012,
    rx: 22.226,
    transform: "rotate(-7.447 432.859 183.269)",
    fill: "#FFEFE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 432.859,
    y: 183.269,
    width: 44.453,
    height: 65.012,
    rx: 22.226,
    transform: "rotate(-7.447 432.859 183.269)",
    fill: "url(#il_error_640px_svg__a)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 169.686,
    y: 173.618,
    width: 44.453,
    height: 65.012,
    rx: 22.226,
    transform: "rotate(6.571 169.686 173.618)",
    fill: "#FFEFE6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169.686,
    y: 173.618,
    width: 44.453,
    height: 65.012,
    rx: 22.226,
    transform: "rotate(6.571 169.686 173.618)",
    fill: "url(#il_error_640px_svg__b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M330.406 129.397c-2.646 11.483 4.518 22.937 16.001 25.583l9.582-41.585c-11.484-2.646-22.937 4.518-25.583 16.002Z",
    fill: "#FFEFE6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.785,
    cy: 37.785,
    transform: "matrix(-1 0 0 1 315.057 47.48)",
    fill: "#513520",
    r: 37.785
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.785,
    cy: 37.785,
    transform: "matrix(-1 0 0 1 322.836 95.268)",
    fill: "#513520",
    r: 37.785
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.785,
    cy: 37.785,
    transform: "matrix(-1 0 0 1 322.836 144.167)",
    fill: "#513520",
    r: 37.785
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M545.66 131.942c-13.058 131.973-170.591 63.069-177.815 0 0-49.102 39.805-88.907 88.908-88.907 49.102 0 88.907 39.805 88.907 88.907Z",
    fill: "#000"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.09,
    cy: 106.937,
    rx: 100.299,
    ry: 100.577,
    fill: "#513520"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 437.305,
    cy: 113.605,
    fill: "#000",
    r: 101.132
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.082,
    cy: 131.942,
    fill: "#FFEFE6",
    r: 91.686
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M307.277 132.22c0 50.637-34.937 84.74-85.574 84.74s-91.686-41.049-91.686-91.686c0-50.636 41.049-91.686 91.686-91.686 50.637 0 85.574 47.995 85.574 98.632Zm235.438 2.138c2.257 16.372-9.186 31.473-25.558 33.729l-7.337-45.313c9.724-17.504 30.639-4.787 32.895 11.584Z",
    fill: "#FFEFE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M436.471.248c52.938 0 95.853 42.79 95.853 95.576H340.617c0-52.785 42.915-95.576 95.854-95.576Z",
    fill: "#DBC0B0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M436.471.248c52.938 0 95.853 42.79 95.853 95.576H340.617c0-52.785 42.915-95.576 95.854-95.576Z",
    fill: "url(#il_error_640px_svg__c)",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M504.405 103.681a1.154 1.154 0 0 1-.239-.667c-.592-20.538-9.962-30.47-27.509-47.996-.815-.815-.012-2.183 1.094-1.858l50.989 15.025c.418.123.724.458.776.89 1.852 15.233-2.51 55.434-7.502 74.016-.304 1.133-1.82.973-1.983-.189-2.363-16.84-5.669-26.406-15.626-39.221Zm-75.123 33.354c1.093-3.997 4.632-4.206 8.628-3.113 3.996 1.092 6.936 3.074 5.843 7.07a7.501 7.501 0 1 1-14.471-3.957Zm-167.813 1.111c1.093-3.996 4.632-4.206 8.628-3.113 3.996 1.093 6.936 3.074 5.843 7.071a7.5 7.5 0 0 1-9.214 5.256 7.5 7.5 0 0 1-5.257-9.214Zm138.356-.748c-1.093-3.996-4.632-4.206-8.628-3.113-3.996 1.093-6.936 3.074-5.843 7.071a7.5 7.5 0 0 0 9.214 5.256 7.5 7.5 0 0 0 5.257-9.214Zm-167.814 1.111c-1.093-3.996-4.632-4.206-8.628-3.113-3.996 1.093-6.936 3.075-5.843 7.071a7.501 7.501 0 1 0 14.471-3.958Z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M404.52 164.449c5.001-5.834 15.003-5.556 20.004 0m-187.261 3.995c5.001-5.835 15.003-5.557 20.003 0",
    stroke: "#E5AFAC",
    strokeWidth: 3.334,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.511,
    cy: 50.943,
    rx: 31.673,
    ry: 40.841,
    transform: "rotate(26.572 210.511 50.943)",
    fill: "#513520"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.353,
    cy: 53.658,
    rx: 37.785,
    ry: 7.779,
    transform: "rotate(40.92 270.353 53.658)",
    fill: "#513520"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.576,
    cy: 87.488,
    fill: "#513520",
    r: 37.785
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.576,
    cy: 87.488,
    fill: "#513520",
    r: 37.785
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.471,
    cy: 57.482,
    fill: "#513520",
    r: 25.56
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.017,
    cy: 133.053,
    fill: "#513520",
    r: 37.785
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.017,
    cy: 184.175,
    fill: "#513520",
    r: 37.785
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.795,
    cy: 225.295,
    fill: "#513520",
    r: 37.785
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M454.531 168.075c0 5.209-4.354 9.432-9.724 9.432-5.371 0-9.724-4.223-9.724-9.432 0-8.156 5.566-15.112 8.276-18.014a1.91 1.91 0 0 1 2.856.036c2.694 3.017 8.316 10.238 8.316 17.978Zm-230.049-2.223c0 5.21-4.354 9.432-9.724 9.432-5.371 0-9.724-4.222-9.724-9.432 0-8.155 5.567-15.111 8.276-18.014a1.91 1.91 0 0 1 2.856.036c2.695 3.017 8.316 10.238 8.316 17.978Z",
    fill: "#97CFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M241.525 136.985c.307-7.359-5.41-13.573-12.769-13.88l-20.364-.849c-7.359-.307-13.573 5.41-13.88 12.768l-.241 5.772c-.46 11.039 8.115 20.36 19.154 20.821l7.039.293c11.039.461 20.36-8.114 20.821-19.153l.24-5.772Zm7.407.369c-.307-7.359 5.41-13.574 12.769-13.88l19.43-.811c7.359-.307 13.573 5.41 13.88 12.769l.209 4.996c.46 11.038-8.115 20.36-19.153 20.82l-6.106.255c-11.039.46-20.361-8.115-20.821-19.153l-.208-4.996Z",
    stroke: "#000",
    strokeWidth: 4.445
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.88 130.54c-2.257 16.371 9.186 31.472 25.558 33.729l7.337-45.314c-9.724-17.503-30.639-4.787-32.895 11.585Z",
    fill: "#FFEFE6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.006,
    cy: 141.249,
    rx: 10.582,
    ry: 28.985,
    transform: "rotate(10.428 154.006 141.249)",
    fill: "#513520"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 224.335,
    y: 231.408,
    width: 199.779,
    height: 134.203,
    rx: 14.585,
    fill: "#202020"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 224.335,
    y: 231.408,
    width: 199.779,
    height: 134.203,
    rx: 14.585,
    fill: "url(#il_error_640px_svg__d)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 214.677,
    y: 360.527,
    width: 219.096,
    height: 20.334,
    rx: 10.167,
    fill: "#202020"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M335.478 67.381c.728-4.594 4.243-8.257 8.812-9.133 71.386-13.682 114.632-13.553 186.013.01 4.577.87 8.103 4.536 8.832 9.139l4.155 26.234c1.175 7.418-5.202 13.837-12.641 12.807-71.575-9.914-116.989-9.8-186.666-.031-7.446 1.044-13.834-5.38-12.657-12.807l4.152-26.219Z",
    fill: "#DBC0B0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m299.255 324.025-.528.793c-.526.79.226 1.813 1.141 1.562 6.299-1.725 11.826-2.756 17.075-3.222.636-.057 1.07-.673.974-1.304a12.424 12.424 0 0 1 .084-4.159c1.007-5.381 5.178-9.116 9.318-8.341 4.139.774 6.679 5.764 5.672 11.145-.096.51-.219 1.005-.369 1.482-.206.661.215 1.384.902 1.462 5.487.624 11.253 1.714 17.872 3.119.926.197 1.606-.874 1.043-1.635-7.444-10.063-11.913-18.81-16.571-27.926-3.353-6.564-6.805-13.319-11.534-20.894-.502-.803-1.735-.528-1.887.406-2.735 16.773-9.578 27.055-23.192 47.512Z",
    fill: "#79C1FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M241.152 137.499h7.779v3.89h-7.779z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_640px_svg__a",
    x1: 455.086,
    y1: 183.269,
    x2: 455.086,
    y2: 248.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C48A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DBC0B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_640px_svg__b",
    x1: 191.912,
    y1: 173.618,
    x2: 191.912,
    y2: 238.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C48A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DBC0B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_640px_svg__c",
    x1: 441.75,
    y1: 8.027,
    x2: 436.471,
    y2: 95.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#513520",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il_error_640px_svg__d",
    x1: 324.225,
    y1: 231.408,
    x2: 324.225,
    y2: 365.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })))));
};
export default SvgIlError640Px;